import React, { Component, PropTypes } from 'react'
import { reduxForm } from 'redux-form'
import moment from 'moment'
import LoadingSpinner from 'components/loading-spinner'
import { getSetupformVoucherFields, getSetupformLastVoucherFields, getSetupformCommission } from 'selectors/setupform'
import validate from 'utils/validate'
import SetupformVouchersForm from './setupform-vouchers-form'
import FIELDS from './fields'

const FIELD_NAMES = FIELDS.map(field => field.name)

export class SetupformVouchersFormContainer extends Component {

  render() {
    if (this.props.loading) {
      return <LoadingSpinner />
    }

    return <SetupformVouchersForm {...this.props} />
  }

}

SetupformVouchersFormContainer.propTypes = {
  loading: PropTypes.bool,
}

const dateFormat = 'YYYY-MM-DD[T]HH:mm' // Format required by HTML5 datetime fields

export const mapStateToProps = (state, ownProps) => {
  let initialValues = getSetupformVoucherFields(
    ownProps.setupformId,
    ownProps.instanceGroupId,
    FIELD_NAMES
  )(state)

  if (initialValues) {
    initialValues.onsaleTime = initialValues.onsaleTime != null
      ? moment(initialValues.onsaleTime).format(dateFormat)
      : undefined
    initialValues.offsaleTime = initialValues.offsaleTime != null
      ? moment(initialValues.offsaleTime).format(dateFormat)
      : undefined
    initialValues.voucherValidFrom = initialValues.voucherValidFrom != null
      ? moment(initialValues.voucherValidFrom).format(dateFormat)
      : undefined
    initialValues.voucherValidTo = initialValues.voucherValidTo != null
      ? moment(initialValues.voucherValidTo).format(dateFormat)
      : undefined
  } else {
    initialValues = {}
    const sensibleDefaultValues = getSetupformLastVoucherFields(ownProps.setupformId)(state)
    if (sensibleDefaultValues) {
      initialValues.onsaleTime = sensibleDefaultValues.onsaleTime != null
        ? moment(sensibleDefaultValues.onsaleTime).format(dateFormat)
        : undefined
      initialValues.offsaleTime = sensibleDefaultValues.offsaleTime != null
        ? moment(sensibleDefaultValues.offsaleTime).format(dateFormat)
        : undefined
      initialValues.voucherValidFrom = sensibleDefaultValues.voucherValidFrom != null
        ? moment(sensibleDefaultValues.voucherValidFrom).format(dateFormat)
        : undefined
      initialValues.voucherValidTo = sensibleDefaultValues.voucherValidTo != null
        ? moment(sensibleDefaultValues.voucherValidTo).format(dateFormat)
        : undefined
    }
  }

  const now = moment.utc().local()
  const onsale = now.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  const offsale = now.clone().set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).add(-1, 'day')

  return {
    initialValues: {
      onsaleTime: onsale.format(dateFormat),
      offsaleTime: offsale.format(dateFormat),
      voucherValidFrom: onsale.format(dateFormat),
      voucherValidTo: offsale.format(dateFormat),
      commission: getSetupformCommission(ownProps.setupformId)(state),
      ...initialValues,
    },
    loading: initialValues === null,
  }
}

export default class NamedVoucherForm extends Component { // eslint-disable-line react/no-multi-comp
  constructor(props) {
    super(props)
    this.formConstructor = reduxForm({
      form: `setupformVouchers__${props.instanceGroupId}`,
      fields: FIELD_NAMES,
      validate: validate(FIELDS),
    }, mapStateToProps)(SetupformVouchersFormContainer)
  }

  submit() {
    this.form.submit()
  }

  render() {
    const FormConstructor = this.formConstructor
    return <FormConstructor ref={(c) => { this.form = c }} {...this.props} />
  }
}

NamedVoucherForm.propTypes = {
  instanceGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}



/** WEBPACK FOOTER **
 ** ./src/components/setupform-vouchers-form/setupform-vouchers-form-container.js
 **/